// extracted by mini-css-extract-plugin
module.exports = {"html-content":"HtmlContent_html-content__z-328"};